import React from "react";

interface CircleExclamationProps {
  size?: number | string;
  className?: string;
  color?: string;
}

const CircleExclamation: React.FC<CircleExclamationProps> = ({
  size = 24,
  className,
  color = "#F7F9F9",
}) => {
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 9V3H9V9H7ZM7 13V11H9V13H7Z"
        fill={color}
      />
    </svg>
  );
};

export default CircleExclamation;
